(function () {
  function addYmmContext(form) {
    const bike = window.RT70YMM?.YMM.get();
    if (!bike) return;
    const values = { rt70_y: bike.y, rt70_m: bike.m, rt70_mo: bike.mo };
    Object.entries(values).forEach(([name, value]) => {
      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    });
  }

  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[role="search"]')) addYmmContext(event.target);
  });
})();
